import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import AddressControl from '../../form/AddressControl';
import createForm from "./Form";

class imageForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-4">
                        <TextInput name={this.props.componentConfig.idfield} value={this.props.values[this.props.componentConfig.idfield]} label="Kód"
                                   role="idfield" {...this.props.getFieldProps(this.props.componentConfig.idfield)}/>
                    </div>
                    <div className="col-md-4">
                        <TextInput name="name" value={this.props.values.path} label="Útvonal"
                               saveChanges={this.props.path} {...this.props.getFieldProps("path")}/>
                    </div>
                    <div className="col-md-4">
                        <TextInput name="name" value={this.props.values.name} label="Név"
                                   saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("name")}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TextInput name="copyright" value={this.props.values.copyright} label="Copyright"
                                   saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("copyright")}/>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(imageForm);
